import React from "react";

export default function createWrapperMixin(WrappedComponent) {
    return class Wrapper extends React.PureComponent {
        getWrappedInstance() {
            return this.component;
        }

        render(props, children = null) {
            return <WrappedComponent ref={c => this.component = c} {...props}>{children}</WrappedComponent>;
        }
    };
}


// WEBPACK FOOTER //
// ./src/kpi/common/createWrapperMixin.js